import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiModule } from './ui/ui.module';
import { PdfSignerComponent } from './components/pdf-signer/pdf-signer.component';
import { ViewPdfComponent } from './components/view-pdf/view-pdf.component';
import { DocumentataionComponent } from './components/documentataion/documentataion.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuditTrailComponent } from './components/audit-trail/audit-trail.component';
import { LoaderComponent } from './ui/loader/loader.component';
import { FilterComponent } from './components/filter/filter.component';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { ButtonModule } from 'primeng/button';
import { ApiValidationMessageComponent } from './components/api-validation-message/api-validation-message.component';

const components = [
  PdfSignerComponent,
  ViewPdfComponent,
  DocumentataionComponent,
  AuditTrailComponent,
  FilterComponent,
  ApiValidationMessageComponent
]

@NgModule({
  declarations: [
    ...components
  ],
  imports: [
    CommonModule,
    UiModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    DropdownModule,
    CalendarModule,
    ButtonModule,

  ],
  exports: [
    ...components,
  ]
})
export class SharedModule { }
